<template lang="">

  <v-app   >
    
  <v-main style="background:#eee">
  <!-- <div class="mainPage page" :isMobile="isMobile" > -->

    <!-- <v-container class="main-container"   > -->
        <!-- <v-row id="page-content" style="margin-top:0"> -->
            <!-- <v-col 
                xs="12"
                sm="12"
                lg="12"
                offset-sm="0"
                offset-lg="0"> -->
                    
                        <slot name="page-content"></slot>
         

            <!-- </v-col> -->
        <!-- </v-row> -->
          <!-- </v-container> -->
         <!-- <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="0.6"
        :hoverEffect="false"
        hoverMode="grab"
        :clickEffect="false"
        clickMode="push"
      >
      </vue-particles> -->
        </v-main>
  </v-app>
</template>
 
<style lang="scss">
.mainPage[isMobile="false"]{
  height: 100vh;
  width: 100vw;
  padding:0px 30px;
  display: block;
  z-index: 4000;
}

#particles-js {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
}
</style> 
 <script>
import Vue from "vue";
import VueParticles from "vue-particles";
Vue.use(VueParticles);
export default {
  components: {},

  data: function () {
    return {
      resize: false,
    };
  },
  methods: {},

  mounted() {
    this.resize = !this.resize;
  },
  created() {
    window.addEventListener("resize", () => {
      this.resize = !this.resize;
      console.debug("resizing");
    });
  },

  computed: {
    
    isMobile() {
      return window.innerWidth < 600;
    },
    pageContentMarginTop() {
      let res = this.resize;
      res = !res;
      let height = 0;
      if (this.$refs.mobileNav != undefined)
        height = this.$refs.mobileNav.$el.clientHeight + "px";
      else height = 0;

      return height;
    },
  },
};
</script>